import { CommonModule } from '@angular/common';
import { Component, input, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { FileUploadControl } from '@app/models/form.models';
import { UploadFilesComponent } from '@app/ui-components/upload-files/upload-files.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-proof-of-professional-status-form',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    UploadFilesComponent,
  ],
  templateUrl: './proof-of-professional-status-form.component.html',
  styleUrl: './proof-of-professional-status-form.component.scss',
})
export class ProofOfProfessionalStatusFormComponent implements OnInit {
  public formGroupInput = input.required<FormGroup<FileUploadControl>>();
  proofOfProfessionalStatusForm?: FormArray<FormGroup<FileUploadControl>>;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.proofOfProfessionalStatusForm = this.fb.array([this.formGroupInput()]);
  }
}
